// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"d2863be7","709":"1aa46de4","809":"f73269dd"}[chunkId] + ".chunk.css";
};